import React from 'react';
import { Outlet } from 'react-router-dom';
import MarketingNav from '../components/marketing/MarketingNav';
import MarketingFooter from '../components/marketing/MarketingFooter';

export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-navy-950 text-white">
      <MarketingNav />
      <Outlet />
      <MarketingFooter />
    </div>
  );
}
